import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgRss(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M22.9323 27.5554C22.9323 17.4126 14.5872 9.06656 4.44434 9.06656V4.44434C17.1217 4.44434 27.5554 14.878 27.5554 27.5554H22.9323ZM7.61345 21.2143C9.36026 21.2143 10.7845 22.6386 10.7845 24.3873C10.7845 26.1332 9.35448 27.5554 7.60574 27.5554C5.85989 27.5554 4.44434 26.136 4.44434 24.3873C4.44434 22.6386 5.86471 21.2153 7.61345 21.2143ZM19.7641 27.5554H15.2719C15.2719 21.6149 10.3849 16.7269 4.44434 16.7269V12.2347C12.8481 12.2347 19.7641 19.1526 19.7641 27.5554Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRss);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
